// Import Packages
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Import Pages
import { Checkboxes } from '../../../FlowConfigurationInputs';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import { CredentialPicker } from '../../../FlowConfigurationInputs/CredentialPicker/CredentialPicker';
import VariablePicker from '../../../FlowConfigurationInputs/VariablePicker/VariablePicker';
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';

// Import Material UI
import { FormControlLabel, Radio, RadioGroup, Select, MenuItem } from '@material-ui/core';

// Import Recoil
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { saveAvailable, initialActions, changedFields } from "../../../../recoil-store/recoil-state";

// Import Helpers
import { CheckIfFlowUpdated } from '../../../../helpers/helper';
/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function GetMail({ action, variables, setOpenVariable }) {
    const { t } = useTranslation();
    const [mailAction, setmailAction] = useState(!action.fields?.action?.value && "")
    const initialActionsData = useRecoilValue(initialActions);
    const setSaveAvailable = useSetRecoilState(saveAvailable);
    const [changedFieldsState, setChangeFields] = useRecoilState(changedFields);

    const label = 'CONTENT.CONFIGURATION-FORM.EMAIL.GET-MAIL.';
    const options = {
        checkbox0: { label: label + 'SECURE' },
        checkbox1: { label: label + 'WITHOUT-ATTACH' },
        checkbox2: { label: label + 'WITH-ATTACH' },
        radioButtons: {
            data: [{
                value: 'imap',
                label: label + 'IMAP'
            }, {
                value: 'pop',
                label: label + 'POP'
            }],
            defaultValue: 'imap'
        }
    }
    const [value, setValue] = useState();
    useEffect(() => {
        if (!action.fields.protocol) { action.fields.protocol = { type: 'RADIO', value: options.radioButtons.defaultValue }; }
        setValue(action.fields.protocol.value);
        if (!action.fields.action) {
            action.fields.action = { value: "" };
        } else {
            if (action.fields.action.value.length > 1) {
                setmailAction(action.fields.action.value);
            }
        }
    }, [action])

    const handleChange = (event) => {
        const field = initialActionsData[action.id]?.fields.protocol;
        const oldValue = !field ? undefined : field.value;
        CheckIfFlowUpdated('protocol', action, oldValue, event.target.value, setSaveAvailable, setChangeFields, changedFieldsState);

        setValue(event.target.value);
        action.fields.protocol.value = event.target.value;
        if (event.target.value === "pop" && mailAction === "markasread") {
            action.fields.action.value = "";
            setmailAction("");
        }
    };

    const handleSelect = (event) => {
        const field = initialActionsData[action.id]?.fields.action;
        const oldValue = !field ? undefined : field.value;
        CheckIfFlowUpdated('action', action, oldValue, event.target.value, setSaveAvailable, setChangeFields, changedFieldsState);

        setmailAction(event.target.value);
        action.fields.action.value = event.target.value;
    }
    return (
        <>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'PROTOCOL')} />
                <RadioGroup value={value ? value : options.radioButtons.defaultValue} onChange={handleChange}>
                    {options.radioButtons.data.map((item, itemI) =>
                        <FormControlLabel
                            key={itemI} value={item.value}
                            control={<Radio color="#C4C4C4" size='small' />}
                            label={t(item.label)}
                            labelPlacement="end"
                            size="small"
                        />
                    )}
                </RadioGroup>
            </div>
            <div className="conf-field-container">
                <Checkboxes action={action} inputName="secure" options={options.checkbox0} />
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'HOST')} is_required />
                <TextInput action={action} inputName="host" variables={variables} setOpenVariable={setOpenVariable} isRequired fieldType="string"
                    displayName={t(label + 'HOST')} hideRequired />
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'PORT')} is_required />
                <TextInput action={action} inputName="port" variables={variables} setOpenVariable={setOpenVariable} isRequired fieldType="string"
                    displayName={t(label + 'PORT')} hideRequired />
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'MAIL')} is_required />
                <CredentialPicker action={action} inputName="mail" variables={variables} setOpenVariable={setOpenVariable} isRequired hideRequired />
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'PASSWORD')} is_required />
                <CredentialPicker action={action} inputName="password" variables={variables} setOpenVariable={setOpenVariable} isRequired hideRequired isPassword={true} />
            </div>
            {value === 'imap' &&
                <>
                    <div className="conf-field-container">
                        <FieldLabel name={t(label + 'FROM')} />
                        <TextInput action={action} inputName="from" variables={variables} setOpenVariable={setOpenVariable} fieldType="string" displayName={t(label + 'FROM')} />
                    </div>
                    <div className="conf-field-container">
                        <FieldLabel name={t(label + 'CC')} />
                        <TextInput action={action} inputName="cc" variables={variables} setOpenVariable={setOpenVariable} fieldType="string" displayName={t(label + 'CC')} />
                    </div>
                    <div className="conf-field-container">
                        <FieldLabel name={t(label + 'SUBJECT-CONTAINS')} />
                        <TextInput action={action} inputName="subjectContains" variables={variables} setOpenVariable={setOpenVariable} fieldType="string" displayName={t(label + 'SUBJECT-CONTAINS')} />
                    </div>
                    <div className="conf-field-container">
                        <FieldLabel name={t(label + 'DESC-CONTAINS')} />
                        <TextInput action={action} inputName="descriptionContains" variables={variables} setOpenVariable={setOpenVariable} fieldType="string" displayName={t(label + 'DESC-CONTAINS')} />
                    </div>
                    {/* <div className="conf-field-container">
                        <Checkboxes action={action} inputName="withoutAttach" options={options.checkbox1} />
                        <Checkboxes action={action} inputName="withAttach" options={options.checkbox2} />
                    </div> */}
                    <div className="conf-field-container">
                        <FieldLabel name={t(label + "ACTION")} />
                        <Select
                            value={mailAction}
                            onChange={(e) => handleSelect(e)}
                            variant="outlined"
                            fullWidth
                            style={{ width: "90%" }}
                        >
                            <MenuItem style={{ fontSize: 12 }} value=""><em>None</em></MenuItem>
                            <MenuItem value="markasread">{t(label + 'MARK-AS-READ')}</MenuItem>
                            <MenuItem value="delete">{t(label + 'DELETE')}</MenuItem>
                        </Select>
                    </div>
                </>
            }

            <div className="conf-field-container">
                <FieldLabel name={t(label + 'OUTPUT')} is_required />
                <VariablePicker action={action} inputName="output" variables={variables} setOpenVariable={setOpenVariable} filter="array" isRequired hideRequired />
                <small className="conf-field-desc"><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'array' })}</em></small>
            </div>
        </>
    );
}
export default GetMail;